module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Csk2xA/tc-custom/9781909166417.jpg?1704761579396",
      "alt": "This image is the cover for the book Furies and Fireflies over Korea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Furies and Fireflies over Korea\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The historian and author details the exploits of British and Australian pilots during the Korean War.")]), _c('br'), _c('br'), _vm._v(" With the outbreak of the Korean War, the UN Security Council called on its members to act and 16 nations did, with Britain sending aircraft carriers such as "), _c('i', [_vm._v("HMS Truimph")]), _vm._v(", from which piston-engined Sea Fury fighters and Fairey Firefly fighter-bombers operated."), _c('br'), _c('br'), _vm._v(" This is the story of the British and Australian Fleet Air Arm pilots and their missions over hostile territory, missions carried out with distinction and honor.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Graham A. Thomas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Graham A Thomas is an author and a historian.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grub Street\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0